import { useContext } from 'react'
import { GbsStore } from '.'
import {
  BottomBarInfo,
  BottomBarState,
  GbsState,
  TopBarState
} from './interfaces'

export const useBottomBar = ():
  | (BottomBarState & { info?: BottomBarInfo; isEditing?: boolean })
  | undefined => {
  const contextData = useContext(GbsStore)

  if (contextData?.state) {
    const { currentStepKey, steps } = contextData.state

    return {
      ...steps[currentStepKey]?.bottomBar,
      info: {
        selectedPlans:
          contextData.state.steps.recommendedPlans?.data?.selectedPlans,
        zip: contextData.state.initialQuoteInformation?.zip,
        numberOfEmployees: parseInt(
          contextData.state.initialQuoteInformation?.numberOfEmployees?.toString() ||
            '1'
        ),
        avgAge: contextData.state.steps.recommendedPlans?.data.avgAge,
        contribution: {
          value: contextData.state.steps.contribution?.data.value,
          type: contextData.state.steps.contribution?.data.type,
          dependentContribution:
            contextData.state.steps.contribution?.data.dependentContribution
        }
      },
      isEditing: contextData.state.isEditingBottomBar
    }
  }
}

export const useTopBar = (): TopBarState | undefined => {
  const contextData = useContext(GbsStore)

  if (contextData?.state) {
    const { currentStepKey, steps } = contextData.state

    return steps[currentStepKey]?.topBar
  }
}

export function useStepData<T = any>(
  stepKey: keyof GbsState['steps']
): T | undefined {
  const { state } = useContext(GbsStore)

  if (state && state.steps[stepKey]) {
    return state.steps[stepKey]?.data
  }
}

export const useCurrentStepData = () => {
  const { state } = useContext(GbsStore)
  const { currentStepKey } = state

  const currentStepData = state.steps[currentStepKey]?.data

  if (!currentStepData)
    throw new Error(
      `[useCurrentStepData] Step ${currentStepKey} (current) not found`
    )

  return currentStepData
}

export const useInitialQuoteInformation = () => {
  const { state } = useContext(GbsStore)

  if (state.initialQuoteInformation) return state.initialQuoteInformation

  return null
}

export const useZipCode = () => {
  const { state } = useContext(GbsStore)

  if (state.zipCode) return state.zipCode

  return null
}
